import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toHandlers as _toHandlers, mergeProps as _mergeProps, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "title mt-3 mb-2" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_11 = {
  key: 5,
  class: "mb-5"
}
const _hoisted_12 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_13 = {
  key: 6,
  class: "mb-5"
}
const _hoisted_14 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_15 = { class: "d-flex flex-wrap" }
const _hoisted_16 = { key: 7 }
const _hoisted_17 = { key: 8 }
const _hoisted_18 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_19 = { key: 9 }
const _hoisted_20 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_21 = { key: 10 }
const _hoisted_22 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_23 = { key: 11 }
const _hoisted_24 = { class: "body-1 blue-grey--text darken-5" }
const _hoisted_25 = { key: 12 }
const _hoisted_26 = { class: "body-1 blue-grey--text darken-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.format.answerType === 'sectionLabel')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.format.label), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.format.answerType === 'shortText')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.format.label), 1),
          _createVNode(_component_v_text_field, {
            value: _ctx.answers[_ctx.index].value,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
            rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
            outlined: "",
            dense: ""
          }, null, 8, ["value", "rules"])
        ]))
      : (_ctx.format.answerType === 'mediumText')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.format.label), 1),
            _createVNode(_component_v_textarea, {
              value: _ctx.answers[_ctx.index].value,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
              rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
              "auto-grow": "",
              outlined: "",
              dense: ""
            }, null, 8, ["value", "rules"])
          ]))
        : (_ctx.format.answerType === 'longText')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.format.label), 1),
              _createVNode(_component_v_textarea, {
                value: _ctx.answers[_ctx.index].value,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
                "auto-grow": "",
                outlined: "",
                dense: ""
              }, null, 8, ["value", "rules"])
            ]))
          : _createCommentVNode("", true),
    (_ctx.format.answerType === 'number')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.format.label), 1),
          _createVNode(_component_v_text_field, {
            value: _ctx.answers[_ctx.index].value,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
            rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
            type: "number",
            outlined: "",
            dense: ""
          }, null, 8, ["value", "rules"])
        ]))
      : (_ctx.format.answerType === 'singleSelect')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.format.label), 1),
            _createVNode(_component_v_radio_group, {
              value: _ctx.answers[_ctx.index].value,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
              rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
              row: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.format.options, (o) => {
                  return (_openBlock(), _createBlock(_component_v_radio, {
                    key: o.value,
                    label: o.label,
                    value: o.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "rules"])
          ]))
        : (_ctx.format.answerType === 'multiSelect')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.format.label), 1),
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.format.options, (o) => {
                  return (_openBlock(), _createBlock(_component_v_checkbox, {
                    key: o.value,
                    label: o.label,
                    value: o.value,
                    class: "label-size mr-4",
                    modelValue: _ctx.multiSelected,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.multiSelected) = $event)),
                    "input-value": _ctx.inputMulti({ format: _ctx.format, value: _ctx.multiSelected }),
                    dense: "",
                    "hide-details": ""
                  }, null, 8, ["label", "value", "modelValue", "input-value"]))
                }), 128))
              ])
            ]))
          : (_ctx.format.answerType === 'boolean')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_v_checkbox, {
                  class: "label-size",
                  value: _ctx.answers[_ctx.index].value,
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                  rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
                  label: _ctx.format.label,
                  dense: ""
                }, null, 8, ["value", "rules", "label"])
              ]))
            : (_ctx.format.answerType === 'yyyy' || _ctx.format.answerType === 'year')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.format.label), 1),
                  _createVNode(_component_v_select, {
                    value: _ctx.answers[_ctx.index].value,
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                    rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
                    items: _ctx.yearChoices,
                    outlined: "",
                    dense: ""
                  }, null, 8, ["value", "rules", "items"])
                ]))
              : (_ctx.format.answerType === 'month')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.format.label), 1),
                    _createVNode(_component_v_menu, {
                      ref: `${_ctx.format.key}DateMonthPicker`,
                      modelValue: _ctx.isMonthDatePicker,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isMonthDatePicker) = $event)),
                      "close-on-content-click": false,
                      "nudge-right": 40,
                      transition: "scale-transition",
                      "offset-y": "",
                      "min-width": "auto"
                    }, {
                      activator: _withCtx(({ on, attrs }) => [
                        _createVNode(_component_v_text_field, _mergeProps({
                          value: _ctx.answers[_ctx.index].value,
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                          "prepend-icon": "mdi-calendar",
                          outlined: "",
                          dense: "",
                          readonly: ""
                        }, attrs, _toHandlers(on)), null, 16, ["value"])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_date_picker, {
                          value: _ctx.answers[_ctx.index].value,
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                          onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isMonthDatePicker = false)),
                          "hide-header": "",
                          scrollable: "",
                          locale: "ja",
                          "full-width": "",
                          type: "month",
                          "day-format": date => new Date(date).getDate()
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              text: "",
                              color: "primary",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMonthDatePicker = false))
                            }, {
                              default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                _createTextVNode(" キャンセル ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              text: "",
                              color: "primary",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$refs[`${_ctx.format.key}DateMonthPicker`].save(_ctx.pickupDate)))
                            }, {
                              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                _createTextVNode(" OK ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "day-format"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : (_ctx.format.answerType === 'date')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.format.label), 1),
                      _createVNode(_component_v_menu, {
                        ref: `${_ctx.format.key}DatePicker`,
                        modelValue: _ctx.isDatePicker,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isDatePicker) = $event)),
                        "close-on-content-click": false,
                        "nudge-right": 40,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto"
                      }, {
                        activator: _withCtx(({ on, attrs }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            value: _ctx.answers[_ctx.index].value,
                            onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                            "prepend-icon": "mdi-calendar",
                            outlined: "",
                            dense: "",
                            readonly: ""
                          }, attrs, _toHandlers(on)), null, 16, ["value"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_date_picker, {
                            value: _ctx.answers[_ctx.index].value,
                            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                            onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isDatePicker = false)),
                            "hide-header": "",
                            scrollable: "",
                            locale: "ja",
                            "full-width": "",
                            "day-format": date => new Date(date).getDate()
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_btn, {
                                text: "",
                                color: "primary",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isDatePicker = false))
                              }, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createTextVNode(" キャンセル ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_v_btn, {
                                text: "",
                                color: "primary",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$refs[`${_ctx.format.key}DatePicker`].save(_ctx.pickupDate)))
                              }, {
                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                  _createTextVNode(" OK ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value", "day-format"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : (_ctx.format.answerType === 'mm')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.format.label), 1),
                        _createVNode(_component_v_select, {
                          value: _ctx.answers[_ctx.index].value,
                          onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                          rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
                          items: _ctx.monthChoices,
                          outlined: "",
                          dense: ""
                        }, null, 8, ["value", "rules", "items"])
                      ]))
                    : (_ctx.format.answerType === 'dd')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.format.label), 1),
                          _createVNode(_component_v_select, {
                            value: _ctx.answers[_ctx.index].value,
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.inputText({ format: _ctx.format, value: $event }))),
                            rules: _ctx.checkRules(_ctx.format.isRequired, _ctx.format.answerType),
                            items: _ctx.dayChoices,
                            outlined: "",
                            dense: ""
                          }, null, 8, ["value", "rules", "items"])
                        ]))
                      : _createCommentVNode("", true)
  ]))
}